import React from "react";
import { useSelector } from "react-redux";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const ENV_ENDPOINTS = {
    local: "http://localhost:3001",
    development: "https://pwg.lafactory.co",
  };
  const link = `${ENV_ENDPOINTS[process.env.REACT_APP_ENV]}/${
    currentActivity._id
  }`;
  return (
    <div
      id="navigation"
      className="navigation py-3"
      // data-spy="affix"
      // data-offset-top="5"
      style={{ backgroundColor: "white" }}
    >
      <div className="media2 d-md-none">
        <div className="social ml-3">
          <ul className="social navbar-nav">
            {[
              "Facebook",
              "Linkedin",
              "Twitter",
              "Instagram",
              "Youtube",
              "GitHub",
            ].map((which, i) => {
              const key =
                which === "Linkedin" ? "linkedIn" : which.toLowerCase();
              {
                /* const KeyIcon = Icon[which]; */
              }
              if (currentActivity && currentActivity.socialLinks[key]) {
                return (
                  <li className="ml-3 ">
                    <a href={currentActivity.socialLinks[key]} target="_blank">
                      <i className={`fa fa-${which}`} />
                    </a>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
      </div>

      <nav className="navbar navbar-default">
        <div
          className="container d-lg-flex"
          style={{ justifyContent: "space-between" }}
        >
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#site-collapse-nav"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <a className="navbar-brand" href={link}>
              <img
                className="logo logo-light"
                src={`${
                  currentActivity && currentActivity.logo
                    ? currentActivity.logo
                    : "--"
                }`}
                alt="logo"
              />
              <img
                className="logo logo-color d-none"
                src={`${
                  currentActivity && currentActivity.logo
                    ? currentActivity.logo
                    : "--"
                }`}
                alt="logo"
              />
            </a>
          </div>

          <div
            id="site-collapse-nav"
            className="collapse d-lg-flex font-secondary my-auto"
            style={{ alignItems: "center" }}
          >
            <ul className="ml-60 mr-4 nav nav-list navbar-nav ">
              <li>
                <a className="nav-item" href="#home">
                  Accueil
                </a>
              </li>
              <li>
                <a className="nav-item" href="#challenge">
                  Challenges
                </a>
              </li>
              <li>
                <a className="nav-item" href="#program">
                  Programme
                </a>
              </li>
              <li>
                <a className="nav-item" href="#faq">
                  FAQ
                </a>
              </li>
              <li>
                <a className="nav-item" href="#contact">
                  Contact
                </a>
              </li>
              <li>
                <a
                  className="button solid-btn sb-h"
                  href={`https://applyforms.lafactory.co/${currentActivity._id}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  // style={{
                  //   backgroundColor: "#638b18",
                  //   border: 0,
                  //   color: "white",
                  // }}
                >
                  S'INSCRIRE
                </a>
              </li>
            </ul>
            <div className="media1 mt-10">
              <div className="social ml-3">
                <ul className="social navbar-nav">
                  {[
                    "Facebook",
                    "Linkedin",
                    "Twitter",
                    "Instagram",
                    "Youtube",
                    "GitHub",
                  ].map((which, i) => {
                    const key =
                      which === "Linkedin" ? "linkedIn" : which.toLowerCase();
                    if (currentActivity && currentActivity.socialLinks[key]) {
                      return (
                        <li className="ml-3 ">
                          <a
                            href={currentActivity.socialLinks[key]}
                            target="_blank"
                          >
                            <i
                              className={`fa fa-${which.toLocaleLowerCase()}`}
                            />
                          </a>
                        </li>
                      );
                    }
                    return null;
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};
